require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/fn/regexp/escape.js
// module id = OzO0
// module chunks = 16